const consoleWarn = console.warn;

// dataAtlasAlignment is a warning that is thrown by the atlas library when it incorrectly passes
// an attribute to a MUI component which does not exist, therefore React does not recognize it.

const SUPPRESSED_WARNINGS = ['dataAtlasAlignment'];
const SUPPRESSED_ERRORS = ['dataAtlasAlignment'];

const filterMessages =
  (filters: string[]) =>
  (msg: unknown, ...args: any[]) => {
    const appearInMessage =
      msg && typeof msg === 'string'
        ? filters.some((entry) => msg.includes(entry))
        : false;
    const appearInArgs =
      args && args.length > 0
        ? args.some(
            (arg) =>
              typeof arg === 'string' &&
              filters.some((entry) => arg.includes(entry)),
          )
        : false;
    if (!appearInMessage && !appearInArgs) {
      consoleWarn(msg, ...args);
    }
  };

console.warn = filterMessages(SUPPRESSED_WARNINGS);

console.error = filterMessages(SUPPRESSED_ERRORS);
